import React, { FC } from "react";

/** The CSS classes below are defined in index.html for splash screen */
const Loader: FC<{ className?: string }> = ({ className = "" }) => (
  <div className={`sk-three-bounce ${className}`}>
    <div className="sk-child sk-bounce1"></div>
    <div className="sk-child sk-bounce2"></div>
    <div className="sk-child sk-bounce3"></div>
  </div>
);

export default Loader;
